import { render, staticRenderFns } from "./FlightSearch.vue?vue&type=template&id=4b537416&scoped=true"
import script from "./FlightSearch.vue?vue&type=script&lang=js"
export * from "./FlightSearch.vue?vue&type=script&lang=js"
import style0 from "./FlightSearch.vue?vue&type=style&index=0&id=4b537416&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b537416",
  null
  
)

export default component.exports